var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCompanyInfo = function SvgIconCompanyInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5A855",
    d: "M8 18.773 2.697 13.47a7.5 7.5 0 1 1 10.606 0zm4.125-6.482a5.833 5.833 0 1 0-8.25 0L8 16.416zM8 9.833A1.667 1.667 0 1 1 8 6.5a1.667 1.667 0 0 1 0 3.333"
  })));
};
export default SvgIconCompanyInfo;